import { LOADING } from "../actionType/roleManagementType";
import { TEAM_USERS, TEAMS } from "../actionType/teamManagementType";
import { accountTeams, teamUsers } from "../constant/Constant";
import {
  deleteAuthMethod,
  getAuthMethod,
  patchAuthMethod,
  postAuthMethod,
} from "../services/HttpServices";

export const createAccountTeam = (payload) => (dispatch) => {
  return postAuthMethod(accountTeams, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const updateAccountTeam = (payload) => (dispatch) => {
  return patchAuthMethod(accountTeams, payload?.id, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const deleteAccountTeam = (id) => (dispatch) => {
  return deleteAuthMethod(`${accountTeams}/${id}`)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getAllTeams = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  const params = Object.entries(payload)
    ?.filter(([key, value]) => key !== "sort")
    .map(([key, value]) =>
      [].includes(key)
        ? `${key}.equals=${value}`
        : key === "globalSearchTerm"
          ? `${key}.contains=${value}`
          : `${key}=${value}`
    )
    .join("&");

  return getAuthMethod(
    `${accountTeams}?sort=${payload?.sort ? payload?.sort : "teamName,asc"}&size=10&${params}`
  )
    .then((res) => {
      dispatch({
        type: TEAMS,
        payload: res.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: TEAMS,
        payload: [],
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const searchTeams = (searchKeyword) => (dispatch) => {
  return getAuthMethod(
    `${accountTeams}?sort=teamName,asc&size=10${searchKeyword ? `&teamName.contains=${searchKeyword}` : ""}`
  )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const getTeamUsers = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return getAuthMethod(`${teamUsers}?teamId=${payload?.id}`)
    .then((res) => {
      dispatch({
        type: TEAM_USERS,
        payload: res.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const deleteUserFromTeam = (id) => (dispatch) => {
  return deleteAuthMethod(`${teamUsers}/${id}`)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};
